var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.props.selectedPlan.current != true
    ? _c(
        "gg-card",
        {
          staticClass: "mb-4"
        },
        [
          _c("gg-card-header", [_vm._v("Plan Details")]),
          _c(
            "gg-card-text",
            [
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          md: "4"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "h1 font-weight-medium mb-1"
                          },
                          [_vm._v(_vm._s(_vm.props.selectedPlan.name))]
                        ),
                        _c("div", [
                          _vm._v(
                            "Upgrading from " +
                              _vm._s(_vm.props.currentPlan.name)
                          )
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "caption"
                          },
                          [
                            _vm._v(
                              " * Regular renewal price of " +
                                _vm._s(
                                  _vm.props.moneyFormat(
                                    _vm.props.selectedPlan.price_renewal_monthly
                                  )
                                ) +
                                "/month applies after the initial upgrade period. "
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          md: "4"
                        }
                      },
                      [
                        _c("div", [_vm._v("Term:")]),
                        _c(
                          "div",
                          {
                            staticClass: "h3 font-weight-thin mb-0"
                          },
                          [_vm._v(_vm._s(_vm.props.timeLeft))]
                        ),
                        _c("div", [
                          _vm._v(
                            "Time left until your renewal date of " +
                              _vm._s(_vm.props.renewalDate)
                          )
                        ])
                      ]
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          md: "4"
                        }
                      },
                      [
                        _c("div", [_vm._v("Upgrade Price:")]),
                        _c(
                          "div",
                          {
                            staticClass: "h3 font-weight-thin mb-0"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.props.moneyFormat(
                                    _vm.props.selectedPlan.promotion_type !=
                                      "fixed"
                                      ? _vm.props.selectedPlan.price_monthly
                                      : _vm.props.selectedPlan.price
                                  )
                                ) +
                                _vm._s(
                                  _vm.props.selectedPlan.promotion_type !=
                                    "fixed"
                                    ? "/month"
                                    : ""
                                ) +
                                " "
                            )
                          ]
                        ),
                        !_vm.props.selectedPlan.credit
                          ? _c("div", [
                              _vm._v(
                                " You will be billed " +
                                  _vm._s(
                                    _vm.props.moneyFormat(
                                      _vm.props.selectedPlan.price
                                    )
                                  ) +
                                  " today "
                              )
                            ])
                          : _c("div", [
                              _vm._v(
                                " You will be issued " +
                                  _vm._s(
                                    _vm.props.moneyFormat(
                                      _vm.props.selectedPlan.credit
                                    )
                                  ) +
                                  " in credit today "
                              )
                            ])
                      ]
                    )
                  ],
                  1
                )
              ]
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }